var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEFBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6695 15.627C15.9408 13.3878 17.7775 11.6499 19.995 11.6499C22.2125 11.6499 24.0491 13.3878 24.3204 15.627H26.855C27.1587 15.627 27.405 15.8841 27.405 16.2011V27.3391C27.405 28.5202 26.4811 29.4999 25.335 29.4999H14.665C13.5312 29.4999 12.595 28.5226 12.595 27.3391V16.2011C12.595 15.8841 12.8412 15.627 13.145 15.627H15.6695ZM15.635 16.7753V18.4872C15.635 18.8043 15.8812 19.0613 16.185 19.0613C16.4887 19.0613 16.735 18.8043 16.735 18.4872V16.7753H23.255V18.4872C23.255 18.8043 23.5012 19.0613 23.805 19.0613C24.1087 19.0613 24.355 18.8043 24.355 18.4872V16.7753H26.305V27.3391C26.305 27.8909 25.8689 28.3517 25.335 28.3517H14.665C14.1387 28.3517 13.695 27.8885 13.695 27.3391V16.7753H15.635ZM23.2085 15.627H16.7815C17.044 14.024 18.3861 12.7982 19.995 12.7982C21.6038 12.7982 22.946 14.024 23.2085 15.627Z",
    fill: "#202AD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7051 21.5479C17.7051 22.8079 18.7251 23.8279 19.9951 23.8279C21.2651 23.8279 22.2851 22.8079 22.2851 21.5479H23.8051C23.8051 23.6479 22.0951 25.3479 19.9951 25.3479C17.8951 25.3479 16.1851 23.6479 16.1851 21.5479H17.7051Z",
    fill: "#202AD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag-icon.182d79fc5e8aa02a9867f45aaf0997d1.svg";
export { ForwardRef as ReactComponent };